(() => {
  const dialog = document.getElementById('MAContactPanel');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const form = dialog.querySelector('form');
  const choices = [...dialog.querySelectorAll('[data-ma-opportunity]')];
  const other = dialog.querySelector('[data-ma-other]');
  const otherText = dialog.querySelector('#MAContactOther');
  const groupError = dialog.querySelector('[data-ma-group-error]');
  let opener;
  let previousOverflow;
  const open = (trigger) => {
    if (dialog.open) return;
    opener = trigger || document.activeElement;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.querySelector('[data-ma-contact-result]')?.focus();
  };
  const validateChoices = () => {
    const valid = choices.some(choice => choice.checked);
    choices[0]?.setCustomValidity(valid ? '' : groupError.textContent.trim());
    if (valid) groupError.hidden = true;
    if (otherText) {
      otherText.disabled = !other.checked;
      otherText.required = other.checked;
    }
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-ma-contact-open]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });
  dialog.querySelector('[data-ma-contact-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button, input, textarea, select, a[href], [tabindex="0"]')]
      .filter(element => !element.disabled && element.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow || '';
    if (opener?.isConnected) opener.focus();
  });
  choices.forEach(choice => choice.addEventListener('change', validateChoices));
  choices[0]?.addEventListener('invalid', () => { groupError.hidden = false; });
  form?.addEventListener('submit', event => {
    validateChoices();
    if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
  });
  validateChoices();
  if (dialog.querySelector('[data-ma-contact-result]')) open();
})();
